import { noop } from 'lodash';
import { ABServiceClient } from '@zocdoc/ab';
import { ActionTypes, OPTIMIZELY_PROJECT } from './constants';

const ENDPOINT = process.env.INTERNAL_AWS_API_HOST || process.env.AWS_API_HOST;

function generateABClient(options) {
    return new ABServiceClient({
        basePath: ENDPOINT,
        fetch: options.fetch,
        timeoutInMillis: 1000,
    });
}

export function receivedAssignments(assignments) {
    return {
        type: ActionTypes.RECEIVED_ASSIGNMENTS,
        payload: assignments,
    };
}

function recordedConversion(conversionId) {
    return {
        type: ActionTypes.TRACKED_CONVERSION,
        conversionId,
    };
}

function conversionError(error) {
    return {
        type: ActionTypes.CONVERSION_ERROR,
        payload: error,
    };
}

export function trackConversion({
    conversionId,
    fetch = fetchWithRetries,
    log = noop,
    sessionId,
    url,
    userAgent,
}) {
    const conversionsBody = {
        conversionData: {
            conversions: [{
                conversionId,
                visitorIdType: 'sessionId',
                sessionId,
            }],
            requestOriginUrl: url,
            userAgent,
            projectName: OPTIMIZELY_PROJECT,
        },
    };

    const abClient = generateABClient({ fetch });
    return async dispatch => {
        try {
            await abClient.trackConversion(conversionsBody);
            dispatch(recordedConversion(conversionId));
        } catch (err) {
            log({
                logPrefix: 'trackConversion',
                message: `Error tracking conversion for ${conversionId} from A/B service`,
                error: err.stack,
            });
            dispatch(conversionError(err));
        }
    };
}
